<template>
    <div class="transitions-filters">
        <CustomSelect
            v-if="'flow' in filters"
            :model-value="filters.flow"
            :form-value-text="({ label }) => label[locale]"
            :options="flows"
            emit-prop="id"
            clearable
            class="select--filter"
            placeholder="Flow"
            @update:model-value="onChange('flow', $event)"
        >
            <template #default="{ item: { label } }">
                {{ label[locale] }}
            </template>
        </CustomSelect>
        <CustomSelect
            v-if="'source_state' in filters"
            :model-value="filters.source_state"
            :form-value-text="({ label }) => label[locale]"
            :options="states"
            emit-prop="id"
            clearable
            class="select--filter"
            placeholder="Source state"
            @update:model-value="onChange('source_state', $event)"
        >
            <template #default="{ item: { label } }">
                {{ label[locale] }}
            </template>
        </CustomSelect>
        <CustomSelect
            v-if="'destination_state' in filters"
            :model-value="filters.destination_state"
            :form-value-text="({ label }) => label[locale]"
            :options="states"
            emit-prop="id"
            clearable
            class="select--filter"
            placeholder="Destination state"
            @update:model-value="onChange('destination_state', $event)"
        >
            <template #default="{ item: { label } }">
                {{ label[locale] }}
            </template>
        </CustomSelect>
    </div>
</template>

<script>
import { fetchFlows, fetchStates } from '@speechki-frontend/crm/src/utils/api/statemachine';
import { CustomSelect } from '@speechki-frontend/shared/ui/forms';
import { mapState } from 'vuex';

export default {
    name: 'TransitionsFilters',
    components: {
        CustomSelect,
    },
    props: {
        filters: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            flows: [],
            states: [],
        };
    },
    computed: {
        ...mapState('workspaces', ['workspaces']),
        locale() {
            return this.$i18n.locale;
        },
    },
    async created() {
        this.loading = true;
        try {
            await Promise.all([this.fetchFlows(), this.fetchStates()]);
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async fetchFlows() {
            const { results = [] } = await fetchFlows({ page_size: 500 });
            this.flows = results;
        },
        async fetchStates() {
            const { results = [] } = await fetchStates({ page_size: 500 });
            this.states = results;
        },
        onChange(field, value) {
            this.$emit('filter', { [field]: value });
        },
    },
};
</script>

<style src="./TransitionsFilters.scss" lang="scss"></style>
